/**
 * Sort helpers para las tablas NextUI del backoffice.
 *
 * Uso:
 *   const [sortDescriptor, setSortDescriptor] = useState({ column: 'name', direction: 'ascending' });
 *   const sorted = applySort(filtered, sortDescriptor, {
 *     name: (r) => r.name.toLowerCase(),
 *     size: (r) => r.size,
 *     date: (r) => tsToMillis(r.updated_at),
 *   });
 *
 *   <Table sortDescriptor={sortDescriptor} onSortChange={setSortDescriptor}>
 *     <TableColumn key="name" allowsSorting>Nombre</TableColumn>
 *     ...
 */

export function tsToMillis(value) {
  if (!value) return 0;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (typeof value.toDate === 'function') return value.toDate().getTime();
  if (typeof value === 'number') return value;
  const d = new Date(value);
  return isNaN(d.getTime()) ? 0 : d.getTime();
}

/**
 * Aplica un sort estable según sortDescriptor. Los nulos/undefined van al
 * final independientemente de la dirección. Si la columna no está en
 * keyFns, devuelve el array tal cual.
 */
export function applySort(items, sortDescriptor, keyFns) {
  const column = sortDescriptor?.column;
  const direction = sortDescriptor?.direction;
  const keyFn = column ? keyFns[column] : null;
  if (!keyFn) return items;

  const dir = direction === 'descending' ? -1 : 1;
  return [...items].sort((a, b) => {
    const va = keyFn(a);
    const vb = keyFn(b);
    const aEmpty = va == null || va === '';
    const bEmpty = vb == null || vb === '';
    if (aEmpty && bEmpty) return 0;
    if (aEmpty) return 1;
    if (bEmpty) return -1;
    if (va < vb) return -1 * dir;
    if (va > vb) return 1 * dir;
    return 0;
  });
}
